import React, { ReactNode } from 'react';

interface ConditionalProps {
    condition: boolean;
    children: ReactNode;
}

export const Conditional: React.FC<ConditionalProps> = ({ condition, children }) => {
    return condition ? <>{children}</> : null;
};